var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E7EB",
    strokeWidth: 0.5,
    strokeLinejoin: "round",
    strokeDasharray: "4 4",
    d: "M.25.25h.5v21.5h-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrail);
export default __webpack_public_path__ + "static/media/trail.a33d61aaaeaaa50ab6d67a78a3cd8a0d.svg";
export { ForwardRef as ReactComponent };